import React from 'react';

import HGeneric from '../helpers/HGeneric';
import type { CachedAPIResponse } from '../models/CachedAPIResponse';
import type { ITextFormats } from '../models/ITextFormats';
import CHorizontalScrollContainer from './CHorizontalScrollContainer';
import CLocalizedTextStringStatic from './CLocalizedTextStringStatic';
import CPageModule from './CPageModule';
import CPandasTable, { type CPandasTableProps } from './CPandasTable';

interface CPageModuleSingleTableProps extends CPandasTableProps {
  cacheMeta?: Omit<CachedAPIResponse<any>, 'cacheData'> & { out?: ITextFormats };
}

export default function CPageModuleSingleTable(props: CPageModuleSingleTableProps) {
  const cacheLabel = CLocalizedTextStringStatic('globalCacheUpdatedAt');

  return (
    <CPageModule fullWidth>
      <CHorizontalScrollContainer>
        <CPandasTable {...props} />
      </CHorizontalScrollContainer>
      {props.cacheMeta && (
        <CPageModule submodule style={{ paddingTop: 0 }}>
          <p className={'mr-2 -mt-2 text-xs text-right'}>
            {cacheLabel}
            {HGeneric.formatString(props.cacheMeta?.cacheTimestamp, { in: 'tzTimestamp', out: props.cacheMeta?.out })}
          </p>
        </CPageModule>
      )}
    </CPageModule>
  );
}
